import React from "react";

import "./Header.style.css";

const Header = () => {
  return (
    <div className="header">
      <h1>To Do List Web App</h1>
    </div>
  );
};

export default Header;
